import { Component, signal, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { DownloadAppButtons } from '../../../components/shared/download-app-buttons';

@Component({
  selector: 'allas-como-me-uno-al-programa',
  imports: [DownloadAppButtons],
  template: `
    <section
      class="py-4 w-full max-w-xl mx-auto flex flex-col items-center justify-center"
    >
      <h2
        class="text-xl xl:text-2xl font-semibold fs-condensed text-gray-900 text-center py-4"
      >
        ¿Como me uno al programa Allas Repuestos Recompensas?
      </h2>
      <p
        [class]="
          isMobile()
            ? 'text-sm fs-condensed text-center leading-relaxed px-6'
            : 'text-center xl:text-lg'
        "
      >
        Con la app de ALLAS Repuestos, cuidar tu vehículo es más fácil que
        nunca. Pide las piezas y accesorios adecuados para tu auto o camioneta
        con solo unos toques.
        <br />
        @if(isMobile()){
        <br />
        } Consigue las piezas que necesitas rápidamente con recogida en tienda
        el mismo día o con la cómoda entrega a domicilio, incluyendo entrega al
        día siguiente para más de 100,000 partes. Consulta tu saldo de
        Recompensas ALLAS y obtén información sobre tu tienda local directamente
        desde la pantalla de inicio. Además lleva el registro e historia de la
        garantía de tu Batería.
      </p>
      <allas-download-app-buttons />
    </section>
  `,
})
export class ComoMeUnoAlPrograma {
  private platformId = inject(PLATFORM_ID);
  isMobile = signal(false);

  constructor() {
    // Detectar si es mobile solo en el browser
    if (isPlatformBrowser(this.platformId)) {
      this.checkIfMobile();

      // Escuchar cambios de tamaño de ventana
      window.addEventListener('resize', () => this.checkIfMobile());
    }
  }

  private checkIfMobile(): void {
    if (isPlatformBrowser(this.platformId)) {
      // Considerar mobile si el ancho es menor a 1280px (breakpoint xl de Tailwind)
      this.isMobile.set(window.innerWidth < 1280);
    }
  }
}
